export enum FreelancingExperienceId {
    STARTING = 'STARTING',
    INTERMEDIATE = 'INTERMEDIATE',
    EXPERT = 'EXPERT',
}

export type FreelancingExperience = {
    id: FreelancingExperienceId;
    title: string;
    name: 'one-block--high' | 'few-blocks--high' | 'many-blocks--high';
};
